export default {
  home: {

  },
  privacyPolicy: {
    header: 'Privacy Policy'
  }
}
